import { FC } from 'react';
import { MediaManager } from 'src/manager/MediaManager';
import { SvgIcon } from '../SvgIcon';
import './styles.scss';

type Props = {
  amount: number;
};

const VisualCurrencyIcon: FC<Props> = ({ amount }) => {
  return (
    <div className={'coins_wrapper'}>
      <SvgIcon
        src={MediaManager.getSrcFromMediaAssets('visualCurrency.svg', '/icons/svg/')}
        className="visual-currency"
      />
      {amount?.toFixed()}
    </div>
  );
};
export default VisualCurrencyIcon;
